import Joi from '@ads/front-core/utils/joi'
import { mailAddressValidation } from '@ads/front-core/validation'

export interface IForm {
  email: string
  phone: string
  name: string
}

export const joiSchema = Joi.object<IForm>({
  phone: Joi.phone().required(),
  email: mailAddressValidation.required(),
  name: Joi.textField().required(),
})
